import * as React from 'react';

const ArrowRight12 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 12 12", width: 12, height: 12, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M.75 5.961c0 .325.259.588.578.588h8.053l-3.382 3.719a.59.59 0 0 0 .035.83.57.57 0 0 0 .806-.032l4.2-4.528a.793.793 0 0 0 0-1.075L6.838.933A.566.566 0 0 0 6.036.9a.59.59 0 0 0-.031.83L9.38 5.375H1.328a.583.583 0 0 0-.578.587Z"
  }
));
ArrowRight12.Size = 12;
ArrowRight12.Title = "ArrowRight";

export { ArrowRight12 as default };
